<template>
  <div class="container my-1 font-be-vietnam">
    <div class="row breadcrumbs">
      <div class="col-12 col-md-7">
        <ul
          class="breadcrumbs d-flex align-items-center pl-0 mb-1"
          style="list-style-type: none;"
        >
          <li style="padding-right: 10px;">
            <router-link :to="{ path: '/' }">
              <feather-icon
                icon="HomeIcon"
                width="18px"
                height="18px"
              />
            </router-link>
          </li>
          <span class="icon" />
          <li>
            <router-link
              title="Mulitmedia"
              :to="{ path: 'mulitmedia', params: { slug: 'tin-moi' } }"
              class="font-weight-600"
              style=" color:#0B438D !important"
            > Mulitmedia
            </router-link>
          </li>
          <li class="sub-list">
            <ul>
              <template v-for="item in breadcrumbs">
                <li
                  :key="item.name"
                  :class="resolveActiveClass(item)"
                >
                  <a :href="item.path">{{ item.name }}</a>
                </li>
              </template>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <b-card
      class="mb-1"
      title="Upload vào dalet"
    >
      <!-- FILE UPLOAD -->
      <file-upload
        ref="uploadMamFileRef"
        class="mb-1"
        :auto-upload="true"
        :remove-file-after-success="true"
        :close-modal-after-all-success="false"
        input-id="input-upload-mam-file"
      />
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCardHeader,
} from 'bootstrap-vue'
import FileUpload from '../files/components/FileUpload.vue';
import useHome from './useHome';

export default {
  components: {
    FileUpload,
    BCard,
    BCardHeader,
  },
  data() {
    return {
    }
  },
  setup(props, ctx) {
    const { breadcrumbs, resolveActiveClass } = useHome();
    return {
      breadcrumbs,
      resolveActiveClass,
    }
  },
  beforeMount() {
    this.$store.dispatch('settings/getListByGroup', { group: 'files' }).then((res) => {
      if (res.status === 200) {
        this.$store.commit('app/UPDATE_SETTING', { app: res.data.data });
      }
    })
  },

}
</script>
<style lang="scss"></style>
